module.exports = __webpack_public_path__ + "static/img/18.ea97010.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/18.png
// module id = X+fS
// module chunks = 0